<template>
    <!--基本信息-->
    <div>
        <div class="common-form">基本信息</div>
        <div class="table-wrap">
            <el-row>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">SN：</span>
                        {{ detail.snCode }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">产品类型：</span>
                        <span v-if="detail.receiptType === '1'">ZPOS-电签</span>
                        <span v-if="detail.receiptType === '2'">FPOS-大机</span>
                        <span v-if="detail.receiptType === '3'">ZPOS-买断版</span>
                        <span v-if="detail.receiptType === '4'">FPOS-买断版</span>
                        <span v-if="detail.receiptType === '5'">和融通</span>
                        <span v-if="detail.receiptType === '6'">合利宝</span>
                        <span v-if="detail.receiptType === '7'">电银</span>
                        <span v-if="detail.receiptType === '8'">联动支付</span>
                        <!-- {{ detail.receiptType }} -->
                        <span></span>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">绑定状态：</span>
                        {{ detail.bindingState == '0' ? '未绑定' : '已绑定' }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">绑定时间：</span>
                        {{ detail.bindingTime }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">设备激活状态：</span>
                        {{ detail.activeState == '0' ? '未激活' : '已激活' }}
                    </div>
                </el-col>
                <el-col :span="5">
                    <div class="pb16">
                        <span class="gray9">设备激活时间：</span>
                        {{ detail.activeTime }}
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
        </div>
    </div>
</template>

<script>
import equipmentApi from '@/api/equipment/messagecontrol.js'
export default {
    data() {
        return {
            detail: '', // 获取详情信息
        }
    },
    created() {
        this.getParams()
    },
    methods: {
        /*获取参数*/
        getParams() {
            let self = this;
            // 取到路由带过来的参数
            const params = this.$route.query.deviceId;
            // console.log(params)
            equipmentApi.getEquipmentDetail(
                {
                    deviceId: params
                },
            )
                .then(res => {
                    // console.log(res);
                    self.detail = res.data;
                })
                .catch(error => {
                    // console.log(error);
                });
        },
        // 返回上一页
        cancelFunc() {
            this.$router.back(-1);
        },
    }
}
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/equipment/messagecontrol/detail.vue